import './UploadTagSheetButton.scss';

import { IconUpload } from '@hulu-react-style-components/icons';
import React, { memo, useCallback } from 'react';

import Button from '../../../common/Button';
import Tooltip from '../../../common/Tooltip';
import bem from '../../../utils/bem';
import type { TraffickingPageDrawerData } from '../TraffickingPage/hooks/makePageDrawerPlugin';
import { DrawerType } from '../TraffickingPage/hooks/makePageDrawerPlugin';
import type { CampaignModel } from '../TraffickingPage/modelConverters';
import { UPLOAD_TAG_SHEET_BUTTON_BUTTON_TEXT, UPLOAD_TAG_SHEET_BUTTON_TOOLTIP_MESSAGE } from './constants';

const [block] = bem('upload-tag-sheet-button');

export interface UploadTagSheetButtonProps {
  selectedCampaigns: CampaignModel[];
  isDisabled: boolean;
  tooltipMessage?: string;
  openTraffickingPageDrawer: (data: TraffickingPageDrawerData) => void;
}

const UploadTagSheetButton = ({
  selectedCampaigns,
  isDisabled,
  tooltipMessage = UPLOAD_TAG_SHEET_BUTTON_TOOLTIP_MESSAGE,
  openTraffickingPageDrawer,
}: UploadTagSheetButtonProps): React.JSX.Element => {
  const handleOpenUploadTagSheet = useCallback((): void => {
    openTraffickingPageDrawer({
      drawerType: DrawerType.UPLOAD_TAG_SHEET,
      selectedCampaigns,
    });
  }, [selectedCampaigns, openTraffickingPageDrawer]);

  return (
    <Tooltip id="upload-tag-sheet" message={tooltipMessage} disable={!isDisabled}>
      <Button
        size="medium"
        variant="outlined"
        className={block()}
        disabled={isDisabled}
        aria-label="Upload Tag Sheet"
        icon={<IconUpload />}
        onClick={handleOpenUploadTagSheet}
        data-testid="upload-tag-sheet-button"
      >
        {UPLOAD_TAG_SHEET_BUTTON_BUTTON_TEXT}
      </Button>
    </Tooltip>
  );
};

export default memo(UploadTagSheetButton);
